import { cva } from "cva";

export const headerMobileMenuStyles = cva({
  base: "fixed top-[var(--mds-header-menu-top)] left-0 right-0 bottom-0 z-100 bg-ink-600 transition-opacity duration-250 ease-out-quad max-h-[calc(100dvh-var(--mds-header-menu-top))] pb-32 overflow-y-auto min-[870px]:hidden",
  variants: {
    menuOpen: {
      true: "opacity-100 pointer-events-auto",
      false: "opacity-0 pointer-events-none",
    },
  },
});

export const headerMobileMenuContentStyles = cva({
  base: "flex flex-col gap-4 w-full bg-white rounded-b-md relative z-2",
});
